import Plus from "@components/icones/plus.tsx";
import {
  ageGroup,
  AgressorsInfos,
  DropDownList,
  relationShip,
} from "@modules/plaintes/plaintes.model.ts";
import { Button } from "primereact/button";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import React from "react";
import { FaTimes } from "react-icons/fa";
import { capitalizeFirstLetter } from "@utils/appUtils.ts";
import { AggressorError } from "./agressorInfos.tsx";

const AggressorForm = ({
  index,
  isLast,
  addForm,
  removeForm,
  formsLength,
  handleChange,
  aggressor,
  error,
  clearError
}: {
  index: number;
  isLast: boolean;
  addForm: () => void;
  removeForm: (index: number) => void;
  formsLength: number;
  handleChange: (index: number, field: string, value: any) => void;
  aggressor: AgressorsInfos;
  error?: AggressorError;
  clearError: (index: number, field: string) => void;
}) => {
  const [sex, setSex] = React.useState<string>(aggressor.sex);
    const [selectedAge, setSelectedAge] = React.useState<DropDownList>();
  const [nationality, setNationality] = React.useState<string>(
    aggressor.nationality ?? ""
  );
  const [selectedVictimRelationShip, setSelectedVictimRelationShip] =
    React.useState<DropDownList>();

  React.useEffect(() => {
    if (aggressor.nationality) {
      setNationality(aggressor.nationality);
    }
    if (aggressor.relation) {
      setSelectedVictimRelationShip(aggressor.relation);
    }
    if(aggressor.age){
      const findAge = ageGroup.find(a => a.code === aggressor.age)
      setSelectedAge(findAge)
    }
  }, [aggressor]);

  return (
    <div className="relative grid grid-cols-1 md:grid-cols-2 gap-3">
      {formsLength > 1 && (
        <button
          type="button"
          onClick={() => removeForm(index)}
          className="absolute top-2 right-2 text-red-500 hover:text-red-700"
        >
          <FaTimes size={16} />
        </button>
      )}
      <div className="flex flex-wrap gap-3">
        <div className="column gap-2 w-full">
          <label htmlFor={`lastName-${index}`}>Nom</label>
          <InputText
            id={`lastName-${index}`}
            placeholder="Saisir le nom"
            aria-describedby="username-help"
            onChange={(e) => handleChange(index, "lastName", e.target.value)}
            value={aggressor.lastName.toUpperCase()}
            maxLength={255}
          />
        </div>
      </div>
      <div className="flex flex-wrap gap-3">
        <div className="column gap-2 w-full">
          <label htmlFor={`firstName-${index}`}>Prénom(s)</label>
          <InputText
            id={`firstName-${index}`}
            placeholder="Saisir le prénom"
            aria-describedby="username-help"
            onChange={(e) => handleChange(index, "firstName", e.target.value)}
            value={capitalizeFirstLetter(aggressor.firstName)}
            maxLength={255}
          />
        </div>
      </div>
      <div className="flex flex-wrap gap-3">
        <div className="column gap-2 w-full">
          <label htmlFor={`adresse-${index}`}>Adresse</label>
          <InputText
            id={`adresse-${index}`}
            onChange={(e) => handleChange(index, "adresse", e.target.value)}
            placeholder=""
            value={aggressor.adresse}
            maxLength={255}
          />
        </div>
      </div>
      <div className="column gap-1">
        Sexe (obligatoire)
        <div className="flex flex-wrap gap-3">
          <div className="flex align-items-center radio">
            <RadioButton
              inputId={`homme-${index}`}
              name={`sex-${index}`}
              value={sex}
              onChange={() => {
                setSex("MALE");
                handleChange(index, "sex", "MALE");
                clearError(index, "sex");
              }}
              checked={sex === "MALE"}
            />
            <label htmlFor={`homme-${index}`} className="ml-2">
              Homme
            </label>
          </div>
          <div className="flex align-items-center radio">
            <RadioButton
              inputId={`femme-${index}`}
              name={`sex-${index}`}
              value={sex}
              onChange={() => {
                setSex("FEMALE");
                handleChange(index, "sex", "FEMALE");
                clearError(index, "sex");
              }}
              checked={sex === "FEMALE"}
            />
            <label htmlFor={`femme-${index}`} className="ml-2">
              Femme
            </label>
          </div>
        </div>
        {error?.sex && <small className="text-red-600">{error?.sex}</small>}
      </div>
      <div className="flex flex-wrap gap-3">
        <div className="column gap-2 w-full">
          <label htmlFor={`age-${index}`}>Âge (obligatoire)</label>
          <Dropdown
            id="age"
            value={selectedAge}
            onChange={(e: DropdownChangeEvent) => {
              setSelectedAge(e.value)
              handleChange(index, "age", e.value)
              clearError(index, "age");
            }}
            options={ageGroup}
            optionLabel="name"
            placeholder="---Tranche d'âge---"
            className="w-full md:w-14rem"
          />
          {error?.age && <small className="text-red-600">{error?.age}</small>}
        </div>
      </div>
      <div className="column gap-1">
        Nationalité (obligatoire)
        <div className="flex flex-wrap gap-3">
          <div className="flex align-items-center radio">
            <RadioButton
              inputId={`malagasy-${index}`}
              name={`nationality-${index}`}
              value={nationality}
              onChange={() => {
                setNationality("Malagasy");
                handleChange(index, "nationality", "Malagasy");
                clearError(index, "nationality");
              }}
              checked={nationality === "Malagasy"}
            />
            <label htmlFor={`malagasy-${index}`} className="ml-2">
              Malagasy
            </label>
          </div>
          <div className="flex align-items-center radio">
            <RadioButton
              inputId={`etranger-${index}`}
              name={`nationality-${index}`}
              value={nationality}
              onChange={() => {
                setNationality("Etranger");
                handleChange(index, "nationality", "Etranger");
                clearError(index, "nationality");
              }}
              checked={nationality === "Etranger"}
            />
            <label htmlFor={`etranger-${index}`} className="ml-2">
              Etranger
            </label>
          </div>
        </div>
        {error?.nationality && (
          <small className="text-red-600">{error?.nationality}</small>
        )}
      </div>
      <div className="flex flex-wrap gap-3">
        <div className="column gap-2 w-full">
          <label htmlFor={`relation-${index}`}>Relation avec la victime (obligatoire)</label>
          <Dropdown
            id={`relation-${index}`}
            value={selectedVictimRelationShip}
            onChange={(e: DropdownChangeEvent) => {
              setSelectedVictimRelationShip(e.value);
              handleChange(index, "relation", e.value);
              clearError(index, "relation");
            }}
            options={relationShip}
            optionLabel="name"
            placeholder="---Relation---"
            className="w-full md:w-14rem"
          />
        </div>
        {error?.relation && (
          <small className="text-red-600">{error?.relation}</small>
        )}
      </div>

      {isLast && (
        <div className="flex flex-wrap mt-[28px]">
          <Button
            onClick={addForm}
            className="p-3 h-[38px] rounded-md border border-[#086d33] gap-2 flex items-center justify-center"
          >
            <span style={{ color: "var(--primary-color)" }}>
              Ajouter un autre présumé auteur
            </span>
            <Plus color="var(--primary-color)" />
          </Button>
        </div>
      )}
    </div>
  );
};
export default AggressorForm;
